// (c) chaehongee. Confidential and proprietary.

import { useEffect, useState, type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { clearCheckoutReturnTo } from '../../services/checkoutReturn'
import { getUserProfile } from '../../services/user'
import styles from './StripeCheckoutCallback.module.css'

const FALLBACK_RETURN_TO = '/dashboard?tab=billing'

export function SubscriptionCheckoutCallback(): ReactElement {
    const { t } = useTranslation('billing')
    const [message, setMessage] = useState(() => t('finalizingSubscription'))

    useEffect(() => {
        const run = async () => {
            const params = new URLSearchParams(window.location.search)
            const status = params.get('status')

            if (status === 'cancel') {
                setMessage(t('subscriptionCanceledReturning'))
            } else if (status === 'success') {
                setMessage(t('subscriptionActivated'))
                await bestEffortRefreshProfile()
            } else {
                setMessage(t('returning'))
            }

            // Always go to billing after subscription checkout — not back to /pricing
            clearCheckoutReturnTo()
            window.location.replace(FALLBACK_RETURN_TO)
        }

        void run()
    }, [t])

    return (
        <div className={styles.root}>
            <div className={styles.card}>
                <h2 className={`branded-title ${styles.title}`}>{t('subscriptionCheckoutTitle')}</h2>
                <p className={styles.body}>{message}</p>
            </div>
        </div>
    )
}

async function bestEffortRefreshProfile(): Promise<void> {
    for (const delayMs of [0, 500, 1000, 1500, 2000]) {
        if (delayMs > 0) {
            await sleep(delayMs)
        }
        try {
            await getUserProfile()
            return
        } catch {
            // keep trying
        }
    }
}

function sleep(ms: number): Promise<void> {
    return new Promise((resolve) => window.setTimeout(resolve, ms))
}
